export const PRODUCT_LIST_CATEGORIES: string = 'categories';
export const PRODUCT_COLOR_HEX_ATTRIBUTE_NAME: string = 'Hex color code';
export const PRODUCT_COLOR_RGB_ATTRIBUTE_NAME: string = 'RGB value';
export const PRODUCT_COLOR_NAME_ATTRIBUTE_NAME: string = 'Color Name';
export const PRODUCT_COLOR_CODE_ATTRIBUTE_NAME: string = 'NCS color code';
export const PRODUCT_TYPE_KENTICO_ATTRIBUTE_NAME: string = 'Product Type Kentico';

export const PRODUCT_TYPE_KENTICO_ATTRIBUTE_VALUES = {
  Paint: 'Paint',
} as const;
